import { render, staticRenderFns } from "./AdvisorsList.vue?vue&type=template&id=4890073a&scoped=true&"
import script from "./AdvisorsList.vue?vue&type=script&lang=js&"
export * from "./AdvisorsList.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorsList.vue?vue&type=style&index=0&id=4890073a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890073a",
  null
  
)

export default component.exports